export const DEFAULT_CACHE_TIME = 60000 * 30 // 30 Minutes

export * from './banners'
export * from './auth'

export const HEADING_VALUE = 'heading'

export enum CALENDAR_MODES {
  SINGLE = 'single',
  RANGE = 'range',
  EXPANDED = 'expanded',
}

export enum ACTIVE_CAMPAIGN_TAGS_IDS {
  PAYMENT_FAILED = 4,
  PAYMENT_STARTED = 6,
  PAYMENT_SUCCESS = 7,
}

export enum FEATURE_FLAGS {
  SKIP_PAYMENT = 'skip_payment',
  SKIP_PAYMENT_REQUEST = 'skip_payment_request',
  DISABLE_FB_EVENTS = 'disable_fb_events',
}

export const EVERFLOW_EVENTS = {
  SIGN_UP: 4,
  PAYMENT_STARTED: 11,
}

export const EVERFLOW_OFFER_IDS = {
  HOMEPAGE: 1,
}

export const BINOM_EVENTS = {
  SIGNUP: 4,
  PAYMENT_STARTED: 23,
  SALE: 24,
}

export const FACEBOOK_PIXEL_EVENTS = {
  COMPLETED_REGISTRATION: 'CompleteRegistration',
  PURCHASE_DIFFERENT_AMOUNT: 'PurchaseWithDifferentAmount',
}

export const FACEBOOK_PURCHASE_EVENT_VALUES = {
  SIGNUP: 5,
  VSL: 10,
  PASS_VSL: 25,
  INIT_CHECKOUT: 50,
  PURCHASE: 100,
}
